import { UploadedImage } from 'common/components/imageUploader'
import {
  ScheduleOption,
  EnableVodPlayback,
  YoutubePrivacySchema
} from 'modules/transmission/types'

export enum ProviderOption {
  HOTMART = 'HOTMART',
  EXTERNAL = 'EXTERNAL',
  YOUTUBE_HOTMART = 'YOUTUBE_HOTMART',
  MUX_STUDIO_HOTMART = 'MUX_STUDIO_HOTMART'
}

export interface FormData {
  code?: string,
  currentThumbnail?: string,
  date?: Date,
  description: string,
  enableVodPlayback: EnableVodPlayback,
  hour?: number,
  minute?: number,
  hourMinute?: string,
  name: string,
  provider: ProviderOption,
  schedule: ScheduleOption,
  thumbnail?: UploadedImage,
  url?: string,
  youtubePrivacy?: YoutubePrivacySchema,
  zoneId?: string
}

export interface TransmissionFormProps {
  allowHotmartLive: boolean,
  allowYoutubeHotmart: boolean,
  initialFields: FormData,
  onChangeProvider?: (provider: ProviderOption) => void,
  onSubmit: (fields: FormData) => void,
  editing?: boolean,
  defaultProvider?: ProviderOption,
  skipRestrictions?: boolean,
  isInlineFooter?: boolean,
  hideAnchorMenu?: boolean,
  hideFooter?: boolean
}

export const isProviderOption = (value: string): value is ProviderOption => {
  return Object.values<string>(ProviderOption).includes(value)
}
